<template>
    <v-container>
        <div class="headline font-weight-light text-center my-6">
            Terima kasih telah mendaftar bimbingan belajar Mediko.id
        </div>

        <v-skeleton-loader v-if="! group" type="image"></v-skeleton-loader>
        <template v-else>
            <non-creator-view :group="group" v-if="! isUserCreator"></non-creator-view>

            <v-stepper v-else v-model="step">
                <v-stepper-header>
                    <v-stepper-step :complete="step > 1" step="1">Tambah anggota</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="step > 2" step="2">Lakukan Pembayaran</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="step > 3" step="3">Upload bukti pembayaran</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="4">Menunggu akun aktif</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-row justify="center">
                            <v-col cols="12" class="pb-0 mb-0">
                                <p class="text-center">
                                    Berikan invite link kepada anggota yang ingin bergabung
                                </p>
                            </v-col>
                            <v-col cols="12" sm="8" md="6" lg="4" class="pt-0 mt-0">
                                <v-text-field
                                    ref="inviteLink"
                                    label="Invite link"
                                    readonly
                                    filled
                                    :value="inviteLink"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <h3 class="title text-center">Anggota</h3>

                        <member-list></member-list>

                        <p class="text-center">
                            Lanjutkan apabila semua anggota kelompok sudah terdaftar
                        </p>

                        <div class="text-center">
                            <v-btn @click="step = 2" color="primary">Lanjutkan</v-btn>
                        </div>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <div class="subtitle text-center">
                            Lakukan pembayaran sebesar
                        </div>

                        <div class="display-1 text-center font-weight-light my-4 mx-auto">
                            Rp 1.000.000 ????
                        </div>

                        <div class="subtitle text-center">
                            Melalui
                        </div>

                        <v-row justify="center">
                            <v-col cols="12" sm="10" md="8" lg="6">
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-content>
                                            Rek BNI: 0387-097-273 (a.n. Puja Chrisdianto Manapa)
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            Rek BRI: 027-801-035-540-509 (a.n. Puja Chrisdianto Manapa)
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            GOPAY: 082-257-510-615 (a.n. Puja Manapa)
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>

                        <p class="text-center">
                            Lanjutkan setelah kamu membayar
                        </p>

                        <div class="text-center">
                            <v-btn @click="step = 1" text class="mr-4">Kembali</v-btn>
                            <v-btn @click="step = 3" color="primary">Lanjutkan</v-btn>
                        </div>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <v-row justify="center">
                            <v-col cols="12" sm="10" md="8" lg="6">
                                <v-alert v-if="paymentError" type="error" border="left" colored-border>Terjadi kesalahan, coba lagi</v-alert>
                                <v-file-input
                                    @change="imageChange"
                                    label="Upload bukti pembayaran di sini"
                                    accept="image/*"
                                    prepend-icon="mdi-file-image"
                                    :loading="imageCompressing"
                                ></v-file-input>
                            </v-col>
                        </v-row>

                        <div class="text-center">
                            <v-btn @click="step = 2" text class="mr-4">Kembali</v-btn>
                            <v-btn
                                @click="uploadProof"
                                color="primary"
                                :disabled="! proof"
                                :loading="$store.get('loader/loading', 'payment')"
                            >
                                Selanjutnya
                            </v-btn>
                        </div>
                    </v-stepper-content>

                    <v-stepper-content step="4">
                        <post-waiting></post-waiting>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </template>
    </v-container>
</template>

<script>
import imageCompression from 'browser-image-compression'
import createFormData from '@/tools/createFormData'
import NonCreatorView from '@/components/dashboard/grouppayment/NonCreatorView'
import MemberList from '@/components/dashboard/grouppayment/MemberList'
import PostWaiting from '@/components/dashboard/payment/PostWaiting'

export default {
    components: {
        NonCreatorView,
        MemberList,
        PostWaiting,
    },

    data() {
        return {
            group: null,
            step: 1,
            proof: null,
            imageCompressing: false,
            paymentError: false,
        }
    },

    computed: {
        isUserCreator() {
            return this.$store.get('auth/id') === this.group.creator_id
        },

        inviteLink() {
            return `${process.env.VUE_APP_BASE_URL}join/${this.group.hash}`
        }
    },

    methods: {
        imageChange(file) {
            if (!!file && file.size > 1024 * 1024) {
                this.imageCompressing = true

                imageCompression(file, {
                    maxSizeMB: 2,
                    maxWidthOrHeight: 2000,
                    useWebWorker: false,
                }).then(compressed => {
                    this.proof = compressed
                }).finally(() => {
                    this.imageCompressing = false
                })
            } else {
                this.proof = file
            }
        },

        uploadProof() {
            const data = createFormData({
                payment_proof: this.proof
            })

            this.$api.post('group/payment', data, { loader: 'payment' })
                .then(response => {
                    if (response.data.paid) {
                        this.step = 4
                    } else {
                        this.paymentError = true
                    }
                })
        },
    },

    created() {
        this.$api.get('group')
            .then(response => {
                if (response.data.payment_proof) {
                    this.step = 4
                }

                this.group = response.data
            })
    }
}
</script>
